"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCAL_MOCK_HEADER = exports.GA_CONSENT_COOKIE_FALLBACK = exports.GA_CONSENT_COOKIE = exports.CookieDisclaimer = exports.C_BAR_COOKIE = void 0;
var _InfoDialog = _interopRequireDefault(require("@rio-cloud/rio-uikit/lib/es/InfoDialog"));
var _iframeResizerReact = _interopRequireDefault(require("iframe-resizer-react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _intervalHook = require("./intervalHook");
var _localeHelper = require("./localeHelper");
var _cookieHelper = require("./cookieHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var GA_CONSENT_COOKIE = exports.GA_CONSENT_COOKIE = 'cookie_settings';
var C_BAR_COOKIE = exports.C_BAR_COOKIE = 'c_bar';
var GA_CONSENT_COOKIE_FALLBACK = exports.GA_CONSENT_COOKIE_FALLBACK = 'cookie_fallback';
var LOCAL_MOCK_HEADER = exports.LOCAL_MOCK_HEADER = 'Local IFrame Mock';
var CookieDisclaimer = exports.CookieDisclaimer = function CookieDisclaimer(_ref) {
  var environment = _ref.environment,
    locale = _ref.locale,
    setEnableCookieDisclaimer = _ref.setEnableCookieDisclaimer;
  var getCookieAndSetShowDialog = function getCookieAndSetShowDialog() {
    var cookieValue = (0, _cookieHelper.getCookie)(GA_CONSENT_COOKIE); // main consent cookie
    var cBarCookieValue = (0, _cookieHelper.getCookie)(C_BAR_COOKIE); // main consent cookie
    var cookieFallbackValue = (0, _cookieHelper.getCookie)(GA_CONSENT_COOKIE_FALLBACK); // fallback if rio.cloud is down
    if (cookieValue !== null && cBarCookieValue !== null || cookieFallbackValue !== null) {
      setEnableCookieDisclaimer(false);
    }
  };
  (0, _react.useEffect)(getCookieAndSetShowDialog);
  (0, _intervalHook.useInterval)(getCookieAndSetShowDialog, 100);
  var iframe = /*#__PURE__*/_react.default.createElement("div", {
    className: 'padding-left-0'
  }, environment === 'production' ? /*#__PURE__*/_react.default.createElement(CookieIframe, {
    lang: (0, _localeHelper.localeToLang)(locale)
  }) : /*#__PURE__*/_react.default.createElement(LocalCookieIframe, null));
  return environment === 'production' || environment === 'mock' ? /*#__PURE__*/_react.default.createElement(_InfoDialog.default, {
    show: true,
    content: iframe,
    className: 'CookieDisclaimerModal cookie-disclaimer'
  }) : null;
};
CookieDisclaimer.propTypes = {
  environment: _propTypes.default.string,
  locale: _propTypes.default.string,
  setEnableCookieDisclaimer: _propTypes.default.func
};
var LocalCookieIframe = function LocalCookieIframe() {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, LOCAL_MOCK_HEADER), /*#__PURE__*/_react.default.createElement(_iframeResizerReact.default, {
    id: 'cookie-disclaimer-iframe',
    title: 'iframe',
    inPageLinks: true,
    minHeight: 430,
    src: '../../demo/cookie_disclaimer.html',
    style: {
      width: '1px',
      minWidth: '100%',
      border: '0'
    }
  }));
};
var CookieIframe = function CookieIframe(_ref2) {
  var lang = _ref2.lang;
  return /*#__PURE__*/_react.default.createElement(_iframeResizerReact.default, {
    id: 'cookie-dialog-iframe',
    title: 'iframe',
    inPageLinks: true,
    minHeight: 430,
    src: "https://rio.cloud/".concat(lang, "/cookie-disclaimer"),
    style: {
      width: '1px',
      minWidth: '100%',
      border: '0'
    }
  });
};
CookieIframe.propTypes = {
  lang: _propTypes.default.string
};